var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { updateByCollectionResponse } from "framework/state/collection";
import { load, loadAll, loadLast, update } from "framework/state/loader";
import { LoadingStateDefaults } from "framework/state/loadingstate";
import { setEntityField } from "framework/state/setfield";
import { NoEntityError, updateByEntityResponse } from "framework/validation/validatableentity";
import { createActionsHook, createHook, createSelector, createStore } from "react-sweet-state";
import { apiGetCompetitionEvents, apiGetCompetitionEvent, apiGetCompetition, apiGetCompetitionResult, apiPutApproveInvigilatorReport, apiPutDisapproveInvigilatorReport } from "./endpoint";
import { getDateInstanceWithZeroUTCTimeFromDateString } from "framework/helpers";
import { apiPutUIContext } from "common/uicontext/endpoint";
import { createEventPlanningContextQuery } from "common/uicontext/store";
function competitorResultMapper(cr) {
    var ecr = JSON.parse(JSON.stringify(cr));
    ecr.endingRound = null;
    return ecr;
}
function divideCompetitorsIntoRounds(competitors, roundDescriptions, baseAdjudicators) {
    var rounds = [];
    var crs = [];
    var dances = [];
    var allAdjudicators = structuredClone(baseAdjudicators);
    var varyingAdjudicators = false;
    roundDescriptions.forEach(function (r) {
        if (r.judges !== undefined) {
            r.judges.forEach(function (j) {
                if (allAdjudicators.find(function (a) { return a.id === j.id; }) === undefined) {
                    allAdjudicators.push(j);
                }
            });
        }
    });
    competitors.forEach(function (c) {
        crs.push(competitorResultMapper(c));
    });
    // create list of rounds
    // updated verions with explicit rounds, ordered from first round to final.
    roundDescriptions.filter(function (r) { return true; }).forEach(function (r, i) {
        rounds.push({ round: r.round, competitors: [], number: i + 1, dances: r.dances, adjudicators: r.judges ? r.judges : baseAdjudicators });
        r.dances.forEach(function (d) {
            if (!dances.includes(d)) {
                dances.push(d);
            }
        });
    });
    // determine ending round for each competitor
    var defined;
    crs.forEach(function (competitor) {
        defined = false;
        rounds.forEach(function (r) {
            competitor.rounds.forEach(function (cr) {
                if (r.round == cr.round && !defined) {
                    competitor.endingRound = r.round;
                    // defined = true;
                }
            });
        });
    });
    // fill competitors
    rounds.forEach(function (round) {
        crs.filter(function (c) { return c.rounds.filter(function (rr) { return rr.round == round.round; }).length; }).sort(function (a, b) {
            return a.rounds.filter(function (rr) { return rr.round == round.round; })[0].ranking < b.rounds.filter(function (rr) { return rr.round == round.round; })[0].ranking ? -1 : 1;
        }).forEach(function (competitor) {
            round.competitors.push(competitor);
        });
    });
    var adjudicatorsInEachRound = rounds.map(function (r) { return r.adjudicators.map(function (a) { return a.id; }); });
    if (adjudicatorsInEachRound.length > 1) {
        adjudicatorsInEachRound.forEach(function (adjudicatorsSet, i) {
            if (i > 0) {
                if (JSON.stringify(adjudicatorsInEachRound[0]) !== JSON.stringify(adjudicatorsSet)) {
                    varyingAdjudicators = true;
                }
            }
        });
    }
    if (varyingAdjudicators) {
        allAdjudicators.sort(function (a, b) {
            var result;
            result = a.surname.localeCompare(b.surname, 'cs');
            if (result > 0) {
                return 1;
            }
            if (result < 0) {
                return -1;
            }
            result = a.name.localeCompare(b.name, 'cs');
            if (result > 0) {
                return 1;
            }
            if (result < 0) {
                return -1;
            }
            return 0;
        });
    }
    else {
        allAdjudicators = structuredClone(rounds[0].adjudicators);
    }
    return [rounds, crs, dances, allAdjudicators, varyingAdjudicators];
}
var FilterStateDefaults = {
    entity: {
        year: null,
        month: null,
    },
    errors: __assign({}, NoEntityError),
};
var setFilterEntityField = function (field, value, validator, storeInvalidValue) { return function (store) {
    store.setState(function (draft) {
        setEntityField(draft.filter, field, value, validator, storeInvalidValue);
    });
    loadCompetitionEvents(store);
}; };
var setFilterInitialValues = function (year, month) { return function (store) {
    store.setState(function (draft) {
        draft.filter.entity.year = year.toString();
        draft.filter.entity.month = month.toString();
        draft.eventList.firstLoadingSubmitted = false;
    });
}; };
var EventStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError) });
var loadEventInListIfNeeded = function (eventId, store, forceLoad) {
    if (forceLoad === void 0) { forceLoad = false; }
    var state = store.getState();
    if (state.eventContainers[eventId].event.entity === null || forceLoad === true) {
        var loader = function () { return apiGetCompetitionEvent(eventId); };
        var stateProducer = function (store, _, response) {
            store.setState(function (draft) {
                updateByEntityResponse(draft.eventContainers[eventId.toString()].event, response);
            });
        };
        load(store, loader, stateProducer, function (s) { return s.eventContainers[eventId.toString()].event; });
    }
};
var reloadEventResults = function (eventId) { return function (store) {
    loadEventInListIfNeeded(eventId, store, true);
}; };
var changeInvigilatorReportApproval = function (eventId, approval) { return function (store) {
    var state = store.getState();
    if (state.eventContainers[eventId].event.entity !== null) {
        var loaderFunction_1 = null;
        loaderFunction_1 = approval === true
            ? apiPutApproveInvigilatorReport
            : apiPutDisapproveInvigilatorReport;
        var loader = function () { return loaderFunction_1(eventId); };
        var stateProducer = function (store, _, response) {
            if (response.status.toString() === "204") {
                store.setState(function (draft) {
                    draft.eventContainers[eventId.toString()].event.entity.invigilatorReportPublicationApproved = approval;
                });
            }
        };
        update(store, loader, stateProducer, function (s) { return s.eventContainers[eventId.toString()].eventReport; });
    }
}; };
var loadUIContextForEventPlanning = function (eventId) { return function (store) {
    var loader = function () { return apiPutUIContext(createEventPlanningContextQuery(eventId)); };
    var stateProducer = function (store, _, response) {
        if (response.succeeded) {
            store.setState(function (draft) {
                var _a, _b, _c, _d, _e, _f;
                draft.eventContainers[eventId.toString()].isGeneralInvigilator = ((_c = (_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.event_planning) === null || _c === void 0 ? void 0 : _c.isGeneralInvigilator) || false;
                draft.eventContainers[eventId.toString()].isCompetitionCommissioner = ((_f = (_e = (_d = response === null || response === void 0 ? void 0 : response.data) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.event_planning) === null || _f === void 0 ? void 0 : _f.isCompetitionCommissioner) || false;
            });
        }
        else {
            store.setState(function (draft) {
                draft.eventContainers[eventId.toString()].isGeneralInvigilator = false;
                draft.eventContainers[eventId.toString()].isCompetitionCommissioner = false;
            });
        }
    };
    loadAll(store, loader, stateProducer, function (s) { return s.eventContainers[eventId.toString()].uicontext; });
}; };
var InvigilatorReportStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError) });
var UIContextHelperStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError) });
var EventContainerDefaults = {
    event: EventStateDefaults,
    eventReport: InvigilatorReportStateDefaults,
    uicontext: UIContextHelperStateDefaults,
    isGeneralInvigilator: false,
    isCompetitionCommissioner: false,
};
var EventListStateDefaults = __assign(__assign({}, LoadingStateDefaults), { collection: [], errors: __assign({}, NoEntityError), openEventIds: [], firstLoadingSubmitted: null });
var lastDayOfMonth = function (y, m) {
    return new Date(y, m, 0).getDate();
};
var createEventContainerIfDoesNotExist = function (eventId, draft, eventEntity) {
    if (eventEntity === void 0) { eventEntity = null; }
    if (!(eventId.toString() in draft.eventContainers)) {
        draft.eventContainers[eventId.toString()] = JSON.parse(JSON.stringify(EventContainerDefaults));
    }
    if (eventEntity !== null) {
        if (draft.eventContainers[eventId.toString()].event.entity == null && eventEntity.eventId == eventId) {
            draft.eventContainers[eventId.toString()].event.entity = eventEntity;
        }
    }
};
var loadCompetitionEvents = function (store) {
    var state = store.getState();
    var f_year = state.filter.entity.year;
    var f_month = state.filter.entity.month;
    if (f_year != null && f_month != null) {
        if (f_month.length === 1) {
            f_month = "0".concat(f_month);
        }
        var fromDate_1 = getDateInstanceWithZeroUTCTimeFromDateString(f_year + '-' + f_month + '-01');
        var toDate_1 = getDateInstanceWithZeroUTCTimeFromDateString(f_year + '-' + f_month + '-' + lastDayOfMonth(parseInt(f_year), parseInt(f_month)));
        var loader = function () { return apiGetCompetitionEvents(fromDate_1, toDate_1); };
        var stateProducer = function (store, _, response) {
            store.setState(function (draft) {
                updateByCollectionResponse(draft.eventList, response);
                draft.eventList.collection.forEach(function (e) {
                    createEventContainerIfDoesNotExist(e.eventId, draft);
                });
            });
        };
        loadLast(store, loader, stateProducer, function (s) { return s.eventList; });
    }
};
var loadCompetitionEventsAction = function () { return function (store) {
    store.setState(function (draft) {
        draft.eventList.firstLoadingSubmitted = true;
    });
    loadCompetitionEvents(store);
}; };
var setEventOpenOrClosed = function (eventId) { return function (store) {
    var loadData = false;
    store.setState(function (draft) {
        var index = draft.eventList.openEventIds.indexOf(eventId);
        if (index > -1) {
            draft.eventList.openEventIds.splice(index, 1);
        }
        else {
            draft.eventList.openEventIds.push(eventId);
            loadData = true;
        }
    });
    if (loadData) {
        loadEventInListIfNeeded(eventId, store);
    }
}; };
// Event
var loadEventIfNeeded = function (eventId) { return function (store) {
    var _a, _b;
    var state = store.getState();
    var eventKey = eventId.toString();
    if (((_a = state.event.entity) === null || _a === void 0 ? void 0 : _a.eventId) != eventId) {
        if (eventKey in state.eventContainers) {
            if (state.eventContainers[eventKey].event.entity !== null) {
                store.setState(function (draft) {
                    draft.event.entity = state.eventContainers[eventKey].event.entity;
                    draft.event.initialized = true;
                });
            }
        }
        var state2 = store.getState();
        if (((_b = state2.event.entity) === null || _b === void 0 ? void 0 : _b.eventId) != eventId) {
            var loader = function () { return apiGetCompetitionEvent(eventId); };
            var stateProducer = function (store, _, response) {
                store.setState(function (draft) {
                    updateByEntityResponse(draft.event, response);
                    createEventContainerIfDoesNotExist(eventId, draft, draft.event.entity);
                });
            };
            load(store, loader, stateProducer, function (s) { return s.event; });
        }
    }
}; };
var CompetitionStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError) });
var loadCompetitionIfNeeded = function (competitionId) { return function (store) {
    var _a, _b, _c;
    var state = store.getState();
    if (((_a = state.competition.entity) === null || _a === void 0 ? void 0 : _a.competitionId) != competitionId) {
        var found_1 = false;
        for (var key in state.eventContainers) {
            if (!found_1) {
                (_c = (_b = state.eventContainers[key].event) === null || _b === void 0 ? void 0 : _b.entity) === null || _c === void 0 ? void 0 : _c.competitions.filter(function (c) { return c.competitionId == competitionId; }).forEach(function (c) {
                    store.setState(function (draft) {
                        draft.competition.entity = c;
                    });
                    found_1 = true;
                });
            }
            else {
                break;
            }
        }
        if (!found_1) {
            var loader = function () { return apiGetCompetition(competitionId); };
            var stateProducer = function (store, _, response) {
                store.setState(function (draft) {
                    updateByEntityResponse(draft.competition, response);
                });
            };
            load(store, loader, stateProducer, function (s) { return s.competition; });
        }
    }
}; };
var CompetitionResultStateDefaults = __assign(__assign({}, LoadingStateDefaults), { entity: null, errors: __assign({}, NoEntityError), roundDetailKey: null, competitorDetailId: null, roundsWithCompetitors: [], allCompetitors: [], dances: [], allAdjudicators: [], varyingAdjudicators: false });
var loadCompetitionResultIfNeeded = function (competitionId) { return function (store) {
    var _a;
    var state = store.getState();
    if (((_a = state.competitionResult.entity) === null || _a === void 0 ? void 0 : _a.competitionId) != competitionId) {
        var loader = function () { return apiGetCompetitionResult(competitionId); };
        var stateProducer = function (store, _, response) {
            store.setState(function (draft) {
                var _a;
                if (response.succeeded) {
                    updateByEntityResponse(draft.competitionResult, response);
                    _a = divideCompetitorsIntoRounds(draft.competitionResult.entity.competitors, draft.competitionResult.entity.rounds, draft.competitionResult.entity.officials.filter(function (o) { return o.type === "Adj"; })), draft.competitionResult.roundsWithCompetitors = _a[0], draft.competitionResult.allCompetitors = _a[1], draft.competitionResult.dances = _a[2], draft.competitionResult.allAdjudicators = _a[3], draft.competitionResult.varyingAdjudicators = _a[4];
                }
            });
        };
        load(store, loader, stateProducer, function (s) { return s.competitionResult; });
    }
}; };
var resetCompetitionResultEntity = function () { return function (store) {
    var state = store.getState();
    if (state.competitionResult.entity !== null) {
        store.setState(function (draft) {
            draft.competitionResult.entity = null;
        });
    }
}; };
var setShowSummary = function () { return function (store) {
    store.setState(function (draft) {
        draft.competitionResult.roundDetailKey = null;
        draft.competitionResult.competitorDetailId = null;
    });
}; };
var setShowRound = function (round) { return function (store) {
    store.setState(function (draft) {
        draft.competitionResult.roundDetailKey = round;
        draft.competitionResult.competitorDetailId = null;
    });
}; };
var setShowCompetitor = function (competitor) { return function (store) {
    store.setState(function (draft) {
        draft.competitionResult.roundDetailKey = null;
        draft.competitionResult.competitorDetailId = competitor;
    });
}; };
var StateDefaults = __assign(__assign({}, LoadingStateDefaults), { filter: FilterStateDefaults, eventList: EventListStateDefaults, eventContainers: {}, competition: CompetitionStateDefaults, event: EventStateDefaults, competitionResult: CompetitionResultStateDefaults });
var store = createStore({
    initialState: StateDefaults,
    actions: {
        setFilterEntityField: setFilterEntityField,
        setFilterInitialValues: setFilterInitialValues,
        loadCompetitionEventsAction: loadCompetitionEventsAction,
        loadCompetitionIfNeeded: loadCompetitionIfNeeded,
        loadEventIfNeeded: loadEventIfNeeded,
        loadCompetitionResultIfNeeded: loadCompetitionResultIfNeeded,
        setShowSummary: setShowSummary,
        setShowRound: setShowRound,
        setShowCompetitor: setShowCompetitor,
        resetCompetitionResultEntity: resetCompetitionResultEntity,
        setEventOpenOrClosed: setEventOpenOrClosed,
        reloadEventResults: reloadEventResults,
        changeInvigilatorReportApproval: changeInvigilatorReportApproval,
        loadUIContextForEventPlanning: loadUIContextForEventPlanning,
    },
    name: "CompetitionResults"
});
var useState = createHook(store);
// filter substore
var getResultsFilterState = createSelector(function (state) { return state.filter; }, function (__, props) { return null; }, function (filter, __) { return filter; });
var useResultsFilterState = createHook(store, {
    selector: getResultsFilterState,
});
// eventList substore
var getResultsEventListState = createSelector(function (state) { return state.eventList; }, function (__, props) { return null; }, function (eventList, __) { return eventList; });
var useResultsEventListState = createHook(store, {
    selector: getResultsEventListState,
});
// competition substore
var getCompetitionState = createSelector(function (state) { return state.competition; }, function (__, props) { return null; }, function (competition, __) { return competition; });
var useCompetitionState = createHook(store, {
    selector: getCompetitionState,
});
// event substore
var getEventState = createSelector(function (state) { return state.event; }, function (__, props) { return null; }, function (event, __) { return event; });
var useEventState = createHook(store, {
    selector: getEventState,
});
// competition result substore
var getCompetitionResultState = createSelector(function (state) { return state.competitionResult; }, function (__, props) { return null; }, function (competition_result, __) { return competition_result; });
var useCompetitionResultState = createHook(store, {
    selector: getCompetitionResultState,
});
// only actions
var useResultsActions = createActionsHook(store);
export { StateDefaults as CompetitionResultsDefaults, useState as useCompetitionResults, useResultsFilterState, useResultsEventListState, useCompetitionState, useEventState, useCompetitionResultState, useResultsActions, };
